import {
    ResponsiveContainer,
    Tooltip,
    AreaChart,
    Area,
} from "recharts";

const data = [
    { name: "Mon", value: 0 },
    { name: "Tue", value: 0 },
    { name: "Wed", value: 0 },
    { name: "Thu", value: 0 },
    { name: "Fri", value: 0 },
    { name: "Sat", value: 0 },
    { name: "Sun", value: 0 },
];

const StatCard = ({ label, value, color, currency = false }) => {

    // Custom tooltip: show only if value > 0
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const point = payload[0].payload;
            if (point.value === 0) return null; // hide tooltip if value is 0
            return (
                <div
                    style={{
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        fontSize: "12px",
                        padding: "5px 10px",
                    }}
                >
                    <span>{label}: {currency ? `₹${point.value}` : point.value}</span>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="card shadow-sm rounded-4 p-3 w-100" style={{ borderRadius: "10px" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="fw-semibold">{label}</span>
                <span className="fw-bold " style={{ color: color }}>
                    {currency ? `₹${value}` : value}
                </span>
            </div>

            <div style={{ height: 60 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={data}>
                        <Tooltip content={<CustomTooltip />} />
                        <Area
                            type="monotone"
                            dataKey="value"
                            stroke={color}
                            fill={color}
                            fillOpacity={0.1}
                            strokeWidth={2.5}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default StatCard;
